import { cmtsRouteManifest } from "./cmtsRouteManifest.js";

export function buildCmtsPersonaLandingMap(): ReadonlyMap<string, string> {
  const map = new Map<string, string>();
  for (const route of cmtsRouteManifest) {
    for (const persona of route.personaLandingFor ?? []) map.set(persona, route.path);
  }
  return map;
}

export function findCmtsPersonaLandingPath(persona: string): string | undefined {
  return buildCmtsPersonaLandingMap().get(persona);
}
